import React, { useState, useEffect } from 'react';
import { MaterialStore, CoatingStore, FinishStore, AdditionalRequirementStore } from '../../../../stores';
import UserStore from '../../../../stores/UserStore';

export const usePrefetchQuoteOptions = () => {
    useEffect(() => {
        MaterialStore.getMaterials();
        MaterialStore.getTopMaterials();
        FinishStore.getFinishes();
        CoatingStore.getCoatings();
        // CoatingStore.getTopCoatings();
        AdditionalRequirementStore.getAdditionalRequirements();

        if (!UserStore.isAuthenticated) {
            UserStore.getEmailDomains();
        }
    }, []);
};
